import React from 'react';
import PropTypes from 'prop-types';
import withTranslate from 'components/withTranslate';
import headersCarat from 'img/cb_headers_carat.png';

export const CurrentBallotDetailsHeader = ({ isOpen, toggle, _t }) => {
  return (
    <button
      type="button"
      onClick={toggle}
      className={`current-ballot-details-header details-collapsable-header ${
        isOpen ? 'header-opened' : 'header-closed'
      }`}
      aria-expanded={isOpen}
    >
      <span className="header-text">{_t('Details')}</span>
      <img src={headersCarat} alt={'Toggle details icon'} />
    </button>
  );
};

export default withTranslate(CurrentBallotDetailsHeader);

CurrentBallotDetailsHeader.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  _t: PropTypes.func.isRequired,
};
